// @ts-nocheck
import { Capacitor } from '@capacitor/core';

export interface AppVersionInfo {
  version: string;
  build: string;
  label: string;
}

let cached: AppVersionInfo | null = null;

export async function getAppVersionInfo(): Promise<AppVersionInfo | null> {
  if (!Capacitor.isNativePlatform()) {
    return null;
  }
  if (cached) return cached;

  try {
    const { App } = await import('@capacitor/app');
    const info = await App.getInfo();
    cached = {
      version: info.version,
      build: String(info.build),
      label: `v${info.version} (${info.build})`,
    };
    return cached;
  } catch (e) {
    console.warn('[appVersion] failed to read native app info:', e);
    return null;
  }
}
